import React from "react";

const documents = [
  {
    id: 1,
    title: "माहितीचा अधिकार अधिनियम, 2005-अन्वये स्वयंप्रकटीकरण करावयाची माहिती",
    link: "#", // pdf link किंवा download path
  },
  {
    id: 2,
    title: "माहितीचा अधिकार अधिनियम, २००५ बाबत मार्गदर्शक",
    link: "#",
  },
  {
    id: 3,
    title: "माहिती अधिकार नियम, २००५",
    link: "#",
  },
  {
    id: 4,
    title: "माहितीचा अधिकार अधिनियम, २००५",
    link: "#",
  },
  {
    id: 5,
    title: "आरटीआय पोर्टलची लिंक",
    link: "https://rti.gov.in",
    external: true,
  },
];

const RightToInformation = () => {
  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">माहितीचा अधिकार</h1>

      <div className="bg-white shadow rounded-lg overflow-hidden">
        <table className="min-w-full table-auto">
          <thead className="bg-gray-100">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">अनु. क्र</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">शीर्षक</th>
              <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">डाउनलोड करा</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {documents.map((doc) => (
              <tr key={doc.id}>
                <td className="px-6 py-4 text-gray-700">{doc.id}</td>
                <td className="px-6 py-4 text-gray-700">{doc.title}</td>
                <td className="px-6 py-4">
                  {doc.external ? (
                    <a
                      href={doc.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline"
                    >
                      Visit
                    </a>
                  ) : (
                    <a
                      href={doc.link}
                      download
                      className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 transition"
                    >
                      Download
                    </a>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RightToInformation;
